<template>
  <div class="roadbook">
    <Header :headerTitle="$t('m.roadbook.title')" :hasBackBtn="false"></Header>
    <div>
        <div v-for="(item,index) in roadbookInfo" :key="index" class="info">
            <img  :src="item.image" width="90%" class="info-img">
            <div  class="info-content">{{item.info}}</div>
        </div>
    </div>

  </div>
</template>
<script>
import { roadbookList } from "@/api/roadbook.js";
export default {
  name: "roadbook",
  data() {
    return {
       roadbookInfo:undefined,
       parkingId:undefined
    };
  },
  methods: {
    //加载数据
    loadInfo: function(data) {
      roadbookList(data).then(
        response => {
          if (response.data.status == 200) {
              this.roadbookInfo = response.data.result
          } else {

          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  mounted() {
      this.parkingId = this.$route.params.parkingId
      this.loadInfo(this.parkingId)
  }
};
</script>
<style >
   .info{
       display: flex;
       flex-direction: column;
   }
   .info-img{
       margin:15px
   }
   .info-content{
        margin:15px
   }
</style>


